import React from 'react';
import {Button as ChakraButton} from '@chakra-ui/core';
import {darkgrey, yellow} from 'styles/constants';

export const Button = React.forwardRef(({children, isPrimary, ...props}, ref) => {
	return (
		<ChakraButton
			type="submit"
			py={6}
			bg={isPrimary ? yellow : darkgrey}
			color={isPrimary ? darkgrey : yellow}
			_hover={{bg: isPrimary ? yellow : darkgrey}}
			_active={{bg: isPrimary ? yellow : darkgrey}}
			mb={4}
			w={'100%'}
			ref={ref}
			{...props}
		>
			{children}
		</ChakraButton>
	);
});
